export default {
  "config": {
    "trial": "itc",
    "id": "study-design",
    "type": "design",
    "title": "Network Diagrams for (A) ESS and CGI-C Outcomes and (B) MWT20 and FOSQ Outcomes<sup>6</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "Note that results of FOSQ outcome are not presented here as no significant difference was observed.<sup>6</sup>"
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "itc",
    "id": "study-design",
    "data-type": "design",
    "title": "Network Diagrams for (A) ESS and CGI-C Outcomes and (B) MWT20 and FOSQ Outcomes<sup>6</sup>",
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-note1",
      "footnote-note2"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-note2": "Note that results of FOSQ outcome are not presented here as no significant difference was observed.<sup>6</sup>"
  }
};